export const getOutlineWorker = (): Worker =>
  new Worker(new URL('./outlineWorker/outlineWorker.ts', import.meta.url));

export const proofOfWorkWorker = (): Worker =>
  new Worker(
    new URL('./proofOfWorkWorker/proofOfWorkWorker.ts', import.meta.url)
  );
